<template>
  <ipo3-page>
    <template slot="title">檢舉清單</template>

    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "news-index",
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "檢舉人", id: "username" },
        { name: "新聞", id: "news_title" },
        { name: "檢舉留言", id: "comment_content" },
        { name: "檢舉時間", id: "create_at" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData(page=1,size=10) {
      let self = this;
      this.$http.get("/admin/member/report",{size:size,page:page}).then(res => {
        if (res.code == 200) {
          const { data, total, per_page } = res.data;
          data.forEach(element => {
            element.username = element.member.username;
            element.news_title = element.news?element.news.title:'';
            element.comment_content = element.comment?element.comment.content:"";
          });
          self.pagecount = total;
          self.paginate = per_page;
          self.tableData = data;
        }
      });
    },
    onCreate() {
      this.$router.push({ path: "/news/edit" });
    },
    onHandle(index, id) {
      this.$router.push({ path: `/news/edit/${id}` });
    },
    handleSizeChange(val) {
      this.getData(1, val);
    },
    handleCurrentChange(val) {
      this.getData(val);
    }
  }
};
</script>